<template>
  <AnalyticsWidget
    title="Order Summary"
    subTitle="Summary data for orders"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    >
    <div class="p-2">
      <LoadingPanel :loading="loading" />
      <div v-if="!loading">
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue
              title="Today's Orders"
              :value="summaryData.orderTotalValue">
              {{formatCurrency(summaryData.orderTotalValue)}}
              <template v-slot:info>In {{summaryData.orderTotalCount}} order{{displayCountPlural(summaryData.orderTotalCount)}} created today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Average Daily Order Total"
              :value="summaryData.averageDailyOrderValue">
              {{formatCurrency(summaryData.averageDailyOrderValue)}}
              <template v-slot:info>Average of {{summaryData.averageDailyOrderCount}} order{{displayCountPlural(summaryData.averageDailyOrderCount)}} created daily for {{currentMonthName}}</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
      </div>
    </div>
  </AnalyticsWidget>
</template>


<script>
import moment from 'moment'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

export default {
  name: 'OrderSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow
  },
  props: {
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    currentMonthName() {
      return moment().local().format('MMMM')
    }
  },
  data() {
    return {
      loading: true,
      summaryData: {},
    }
  },
  created() {
  },
  mounted() {
    this.loading = true
    this.requestData()
  },
  methods: {
    requestData() {
      this.$apiService.analyticsService.getOrdersValueTotalSummary()
      .then(response => {
        this.summaryData = response.data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>